import { formatFullName } from 'shared/utils';
import { attendanceModeLabel, getCheckInMethodLabel } from './event-view.helpers';

function escapeCell(cell) {
  return `"${String(cell).replace(/"/g, '""')}"`;
}

export function exportAttendees({
  gridApi,
  fileName,
  attendeesLang,
  eventsLang,
  getValueFromLang,
  formatCheckInTime,
}) {
  const headers = [
    attendeesLang.COLUMN_NAME,
    attendeesLang.COLUMN_ROLE,
    attendeesLang.COLUMN_TYPE,
    attendeesLang.COLUMN_CHECK_IN_TIME,
    eventsLang.CHECK_IN_METHOD,
  ];

  const rows = [];
  gridApi.forEachNodeAfterFilterAndSort(node => {
    const { user, attendanceMode, checkedInAt, method } = node.data;
    rows.push([
      user ? formatFullName(user) : '-',
      getValueFromLang(user?.professional?.role) || '-',
      attendanceModeLabel(attendanceMode, eventsLang),
      checkedInAt ? formatCheckInTime(checkedInAt) : '-',
      getCheckInMethodLabel({ method, lang: eventsLang }) || '-',
    ]);
  });

  const csv = [headers, ...rows].map(row => row.map(escapeCell).join(',')).join('\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${fileName}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
